import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { cartProductEndpoints } from '../../../../constants/endpoints';
import { ICartProduct } from '../../entities/cart-product';
import { AddProductInput, UpdateCartProductInput } from '../../schemas/cart-product.schema';

class CartProductApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  addToCart = async (input: AddProductInput): Promise<AddProductInput> =>
    this.#requestInstance.post(cartProductEndpoints.cartProduct, input);

  getCartProducts = async (id: number): Promise<ICartProduct[]> =>
    this.#requestInstance.get(cartProductEndpoints.cartProductId(id));

  updateCartProducts = async (input: UpdateCartProductInput): Promise<void> =>
    this.#requestInstance.patch(cartProductEndpoints.cartProductId(input.id), input.body);

  deleteCartProducts = async (id: number): Promise<void> =>
    this.#requestInstance.delete(cartProductEndpoints.cartProductId(id));
}

export const cartProductApi = new CartProductApi(axios);
